(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brs-all-products-category"] && !Shopify.designMode) return;
  try {
    
  class BrsAllProductsInfiniteScroll {
    constructor(section) {
      this.section = section;
      this.grid = section.querySelector('[data-brs-all-products-grid]');
      this.pagination = section.querySelector('[data-brs-all-products-pagination]');
      this.nextLink = section.querySelector('[data-brs-all-products-next]');
      this.sortSelect = section.querySelector('[data-brs-all-products-sort]');
      this.loading = false;
      this.collectionUrl = section.dataset.allCollectionUrl;
      this.boundSort = this.changeSort.bind(this);

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', this.boundSort);
      }

      if (!this.grid || !this.pagination || !this.nextLink || !('IntersectionObserver' in window)) {
        return;
      }

      this.section.classList.add('is-infinite-ready');

      this.observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this.loadNextPage();
          }
        },
        { rootMargin: '700px 0px' }
      );

      this.observer.observe(this.pagination);
    }

    async loadNextPage() {
      if (this.loading || !this.nextLink) {
        return;
      }

      this.loading = true;
      this.section.classList.add('is-loading');

      try {
        const response = await fetch(this.nextLink.href);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-brs-all-products-grid]');
        const nextPagination = doc.querySelector('[data-brs-all-products-pagination]');

        if (nextGrid) {
          Array.from(nextGrid.children).forEach(item => {
            this.grid.appendChild(item);
          });
        }

        if (nextPagination) {
          this.pagination.innerHTML = nextPagination.innerHTML;
          this.nextLink = this.pagination.querySelector('[data-brs-all-products-next]');
        } else {
          this.observer.disconnect();
          this.pagination.remove();
          this.nextLink = null;
        }
      } catch (error) {
        this.section.classList.remove('is-infinite-ready');
      }

      this.loading = false;
      this.section.classList.remove('is-loading');
    }

    changeSort() {
      if (!this.sortSelect || !this.collectionUrl || this.sortSelect.value === 'featured') return;

      window.location.assign(`${this.collectionUrl}?sort_by=${encodeURIComponent(this.sortSelect.value)}`);
    }
  }

  document.querySelectorAll('.brs-all-products').forEach(section => {
    new BrsAllProductsInfiniteScroll(section);
  });

  } catch(e) { console.error(e); }
})();
})();
